import * as angular from "angular";
import {IController} from "angular";
import * as _ from "lodash";

export class pricePlanSelectCtrl implements IController {

  pricePlanBundle: any;
  selectedType: any;
  onChange: Function;

  private selected: any;

  /* @ngInject */
  constructor() {
  }

  $onInit() {
    if (this.pricePlanBundle) {
      this.selected = _.find(this.pricePlanBundle.entryList, (entry) => {
        return entry.type === this.selectedType;
      });
    }
  };

  $onChanges(changes) {
    if ((changes.selectedType && !changes.selectedType.isFirstChange()) ||
      (changes.pricePlanBundle && !changes.pricePlanBundle.isFirstChange())) {
      this.$onInit();
    }
  };

  ////////////////////////////////////////////////////////////////////////

  select(entry) {
    if (entry.type !== this.selectedType) {
      this.onChange({pricePlan: entry});
    }
  }

}

angular
  .module('bringoz.admin.orders')
  .component('pricePlanSelect', {
    bindings: {
      pricePlanBundle: '<',
      selectedType: '<',
      onChange: '&'
    },
    template: require('./price-plan-select.html').default,
    controller: pricePlanSelectCtrl
  });
